import styled from '../../../consts/styled';

const NavigationSecondRow = styled.div`
  position: relative;
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(213, 214, 222, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default NavigationSecondRow;
